<template>
  <main class="page-sitemap" id="main" tabindex="-1">
    <h1>Sitemap</h1>
  </main>
</template>

<script>
export default {
  name: 'sitemap'
}
</script>

<style scoped>

</style>
